import React, { useState } from 'react'
import { Form, Accordion, Badge } from 'react-bootstrap'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { buildEventUrl, isTechTalentEvent } from '../../helpers/url'
import styles from '../../styles/JobFilters.module.scss'

interface MRTFilterProps {
  mrtLine: any[]
  eventId: string
  filters: any
  urlBuilder?: (eventId: string, filters: any, mrt?: string) => string
}

const MRTFilter: React.FC<MRTFilterProps> = ({ mrtLine, eventId, filters, urlBuilder }) => {
	const router = useRouter()
	const { t } = useTranslation()

	const isTechTalent = isTechTalentEvent(eventId)
	const badgeStyle = isTechTalent ? { backgroundColor: '#6E368D', color: 'white' } : {}

	const [mrtFilterKeyword, setMrtFilterKeyword] = useState('')
	const [filterMrtLine, setFilterMrtLine] = useState(mrtLine || [])
	const [selectedMrt, setSelectedMrt] = useState(filters.mrt || [])
	const [selectedMrtLine, setSelectedMrtLine] = useState<any[]>([])

	const handleSearchMrt = (searchValue: string, mrtLine: any[]) => {
		const validate = searchValue.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		return mrtLine.map((mrtL: any) => {
			return {
				colour: mrtL.colour,
				id: mrtL.id,
				name: mrtL.name,
				MrtStations: mrtL.MrtStations.filter((mrtS: any) => {
					return mrtS.name.toLowerCase().indexOf(validate.toLowerCase()) > -1
				})
			}
		})
	}

	const isAllMrtChecked = (arr: any[], values: any[]): boolean => {
		return values.every((value: any) => {
			return arr.includes(value)
		})
	}

	const handleSearchMrtFunc = (e: any) => {
		const validate = (e.target.value).replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		setMrtFilterKeyword(validate)
		setFilterMrtLine(handleSearchMrt(validate, mrtLine))
	}

	const mrtSelection = (e: any, mrtLineId: any) => {
		let tempSelectedMrt = Array.from(selectedMrt)
		if (typeof e.target !== 'undefined') {
			const value = e.target.value
			if (tempSelectedMrt.includes(value)) {
				tempSelectedMrt.splice(tempSelectedMrt.indexOf(value), 1)
			} else {
				tempSelectedMrt.push(value)
			}
			tempSelectedMrt = tempSelectedMrt.filter((ele: any) => (ele !== 'others' && ele !== 'multiple'))
			setSelectedMrt(tempSelectedMrt)
		}

		const index = mrtLine.findIndex((mrtl: any) => mrtl.id === mrtLineId)
		let mrtstation = mrtLine[index].MrtStations
		mrtstation = mrtstation.map((mrts: any) => mrts.id)

		let newSelectedMrtLine = [...selectedMrtLine]
		if(isAllMrtChecked(tempSelectedMrt, mrtstation)) {
			newSelectedMrtLine = [...selectedMrtLine, mrtLineId]
		} else {
			newSelectedMrtLine = selectedMrtLine.filter((item: any) => item !== mrtLineId)
		}
		setSelectedMrtLine(newSelectedMrtLine)

		// Update URL
		const mrt: string = tempSelectedMrt.join(',') as string
		const url = urlBuilder ? urlBuilder(eventId, filters, mrt) : buildEventUrl(eventId, filters, mrt)
		router.push(url, undefined, { scroll: false })
	}

	const selectAllMrt = (e: any) => {
		const value = e.target.value

		const currentMrtLine = mrtLine.filter((mrtl: any) => { return mrtl.id === value })[0]
		const currentMrtStationId = currentMrtLine.MrtStations.map((mrts: any) => { return mrts.id })

		let tempSelectedMrt = [...selectedMrt]
		let newSelectedMrtLine = [...selectedMrtLine]

		if (e.target.checked === true) {
			const tempArr = [...new Set([...selectedMrt, ...currentMrtStationId])]
			tempSelectedMrt = tempArr.filter((ele: any) => ele !== 'others')
			newSelectedMrtLine = [...selectedMrtLine, value]
		} else {
			tempSelectedMrt = selectedMrt.filter((smrt: any) => {
				return currentMrtStationId.includes(smrt) === false || smrt === 'others'
			})
			newSelectedMrtLine = selectedMrtLine.filter((e: any) => { return e !== value })
		}

		setSelectedMrt(tempSelectedMrt)
		setSelectedMrtLine(newSelectedMrtLine)

		// Update URL
		const mrt: string = tempSelectedMrt.join(',') as string
		const url = urlBuilder ? urlBuilder(eventId, filters, mrt) : buildEventUrl(eventId, filters, mrt)
		router.push(url, undefined, { scroll: false })
	}

	return (
		<div className={styles.filterSection}>
			<label className={styles.filterLabel}>{isTechTalent ? 'Job Location' : t('filter.mrt')}</label>
			<Form.Control value={mrtFilterKeyword} type='text' placeholder={isTechTalent ? 'Search by MRT' : t('filter.search_by_mrt')} onChange={(e) => { handleSearchMrtFunc(e) }} />
			<div style={{ maxHeight: '40vh', overflow: 'auto', marginTop: '10px' }}>
				<Accordion alwaysOpen>
					{filterMrtLine.map((mrtl: any, i: number) => {
						if (mrtl.MrtStations.length > 0) {
							const mrtIds = mrtl.MrtStations.map((st: any) => st.id.toString())
							const selectedCount = selectedMrt.filter((x: any) => mrtIds.includes(x)).length

							let badge: JSX.Element | null = null
							if (selectedCount === mrtl.MrtStations.length) {
								badge = <Badge pill bg={isTechTalent ? undefined : 'success'} className='mx-2' style={badgeStyle}>All MRT selected</Badge>
							} else if (selectedCount !== 0) {
								badge = <Badge pill bg={isTechTalent ? undefined : 'info'} className='mx-2' style={badgeStyle}>{selectedCount} MRT selected</Badge>
							}

							return (
								<Accordion.Item eventKey={i.toString()} key={i}>
									<Accordion.Header>
										<span style={{ display: 'inline-block', padding: '3px 8px', borderRadius: '3px', backgroundColor: `${mrtl.colour}`, color: 'white', fontSize: '14px' }}>
											{mrtl.id.slice(0, -1)}
										</span> &nbsp; {mrtl.name}
										{badge}
									</Accordion.Header>
									<Accordion.Body >
										<Form.Check
											type='checkbox'
											id={`select-all-${mrtl.id}`}
											value={mrtl.id}
											label={t('sel_all')}
											onChange={(e) => {
												selectAllMrt(e)
											}}
											checked={selectedMrtLine.includes(mrtl.id)}
											className={isTechTalent ? styles.techTalentCheckbox : ''}
										/>
										{mrtl.MrtStations.map((mrts: any, j: number) => {
											return (
												<Form.Check
													checked={selectedMrt.includes(mrts.id)}
													key={`${i}-${j}`}
													value={mrts.id}
													type='checkbox'
													label={mrts.name}
													id={`mrt-station-${mrts.id}`}
													onChange={(e) => {
														mrtSelection(e, mrtl.id)
													}}
													className={isTechTalent ? styles.techTalentCheckbox : ''}
												/>
											)
										})}
									</Accordion.Body>
								</Accordion.Item>
							)
						}
					})}
				</Accordion>
			</div>
		</div>
	)
}

export default MRTFilter